import { render, staticRenderFns } from "./EipDemensionSelector.vue?vue&type=template&id=53d8b376&"
import script from "./EipDemensionSelector.vue?vue&type=script&lang=js&"
export * from "./EipDemensionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports